import { nanoid } from "@reduxjs/toolkit"
import MakerJs, { IModel } from "makerjs"
import { Button } from "react-bootstrap"
import { useSelector } from "react-redux"
import { Channel, Obstacle, Point, RootState, Settings } from ".."
import { Geometry } from "../Utils/Geometry"
import { V } from '../Utils/Vector'
import { createDXF } from "./createDXF"

export { DownloadDXF }

function DownloadDXF(props: {

}) {

  const inputConfiguration = useSelector((state: RootState) => state.inputConfiguration)
  const outputConfiguration = useSelector((state: RootState) => state.output)
  const settings = useSelector((state: RootState) => state.settings)

  return (
    <>
      <Button
        variant="functional"
        onClick={() => {
          downloadFile(makeDXF({
            obstacles: inputConfiguration.obstacles,
            channels: [...Object.values(outputConfiguration.channels)].map(c => c.channel).filter(c => c !== undefined) as Channel[],
            settings
          }), nanoid() + '.dxf')
        }}
        style={{
          margin: '1em'
        }}
      >
        Download DXF Paths
      </Button>
    </>
  )
}

function makeDXF({
  obstacles,
  channels,
  settings
}: {
  obstacles: Obstacle[]
  channels: Channel[]
  settings: Settings
}) {

  const dxf = createDXF(channels.map(c => c.path.pathString))

  return dxf
}

function downloadFile(content: string, name: string) {
  const data = 'data:text/json;charset=utf-8,' + encodeURIComponent(content)
  const downloadAnchorNode = document.createElement('a')
  downloadAnchorNode.setAttribute('href', data)
  downloadAnchorNode.setAttribute('download', name)
  document.body.appendChild(downloadAnchorNode)
  downloadAnchorNode.click()
  downloadAnchorNode.remove()
}
